import axios from 'axios';
import UserProfile from '@/entities/UserProfile';

export default class AuthService {
  constructor(authToken, shopToken) {
    this.authToken = authToken;
    this.shopToken = shopToken;
    this.baseUrl = `${process.env.VUE_APP_MON_COMPTE_BACKEND_URL}/users`;
  }

  async sendResetPasswordRequest(userId, newPassword, shopToken) {
    console.log('Got shop token', shopToken);
    const shopAuthToken = shopToken ?? this.shopToken;
    console.log('sending shop token', shopAuthToken);
    try {
      // TODO : SWAP OPENBAR UPDATE
      // const url = `${this.baseUrl}/${userId}/reset-password`;
      const url = `${this.baseUrl}/${userId}/openbar-reset-password`;
      const userToken = this.authToken;
      const res = await axios.post(url,
        { password: newPassword },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'shop-token': shopAuthToken,
          },
        });
      return new UserProfile(res.data.data);
    } catch (e) {
      return null;
    }
  }

  async changePassword(userId, newPassword) {
    try {
      const url = `${this.baseUrl}/${userId}`;
      const userToken = this.authToken;
      const res = await axios.patch(url,
        { password: newPassword },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        });
      return new UserProfile(res.data.data);
    } catch (e) {
      return null;
    }
  }
}
